// 
// user.js
// Use this to write your custom JS
//

document.addEventListener("DOMContentLoaded", function () {
    
    'use strict'
    
    const forms = document.querySelectorAll('.needs-validation')
    const zipField = document.querySelector("#contact-form input[name='zip']");
    const toField = document.querySelector("#contact-form input[name='to']");

    if (!zipField || !toField) return;

    zipField.addEventListener("input", function () {
        const zipValue = zipField.value.trim();
        if (/^(0|1|2|3|4|5|99|98)/.test(zipValue)) {
            toField.value = "info@be-truckrent.de";
        } else {
            toField.value = "vertrieb@be-truckrent.de";
        }
    });
  
    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
      form.addEventListener('submit', event => {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }
        form.classList.add('was-validated')
      }, false)
    })

});
